import { serialize, parse } from "cookie";
import config from "@/lib/config";
export default class Cookies {
  constructor(req, res) {
    this.req = req;
    this.res = res;
  }
  set(values) {
    var _this$res$getHeader;
    if (!(values instanceof Array)) {
      values = [values];
    }
    const existsCookies = (_this$res$getHeader = this.res.getHeader("Set-Cookie")) !== null && _this$res$getHeader !== void 0 ? _this$res$getHeader : [];
    const cookies = Array.from(values).map(_ref => {
      let {
        name,
        value,
        options = {}
      } = _ref;
      return serialize(name, value, Object.assign({}, config.cookieOptions, options));
    });
    this.res.setHeader("Set-Cookie", [...existsCookies, ...cookies]);
  }
  remove(names) {
    if (!(names instanceof Array)) {
      names = [names];
    }
    this.set(Array.from(names).map(name => {
      if (name instanceof Array) {
        return {
          name: name[0],
          value: "",
          options: Object.assign({
            maxAge: 0
          }, name[1])
        };
      } else {
        return {
          name,
          value: "",
          options: {
            maxAge: 0
          }
        };
      }
    }));
  }
  get(name) {
    const cookies = this.parse();
    return cookies[name];
  }
  parse() {
    var _this$req$headers;
    if (this.req.cookies) return this.req.cookies;
    const cookie = (_this$req$headers = this.req.headers) === null || _this$req$headers === void 0 ? void 0 : _this$req$headers.cookie;
    return parse(cookie || "");
  }
}